var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var SortComponent = /** @class */ (function (_super) {
    __extends(SortComponent, _super);
    function SortComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.recs = [];
        _this.codeKey = '';
        _this.dispKey = '';
        return _this;
    }
    SortComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.codeKey) {
            this.codeKey = this.component.params.codeKey;
        }
        if (this.component.params && this.component.params.displayKey) {
            this.dispKey = this.component.params.displayKey;
        }
    };
    SortComponent.prototype.ngAfterViewInit = function () {
        this.element = this.sortElement.nativeElement;
        var self = this;
        $(this.element).sortable({
            items: 'tbody tr',
            helper: function (event, ui) {
                ui.children().each(function () {
                    $(this).width($(this).width());
                });
                return ui;
            },
            update: function (event, ui) {
                var trs = self.element.querySelectorAll('tbody tr');
                var order = [];
                for (var _i = 0, trs_1 = trs; _i < trs_1.length; _i++) {
                    var tr = trs_1[_i];
                    var o = {};
                    o[self.codeKey] = tr.dataset['code'];
                    o[self.dispKey] = tr.dataset['display'];
                    order.push(o);
                }
                self.setCompRec(order);
            }
        });
        $(this.element).disableSelection();
    };
    SortComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    SortComponent.prototype.onSubscribe = function (data) {
        $('#' + this.componentName + ' > div.tableWrapper').scrollTop(0);
        this.recs = [];
        if (typeof data !== 'undefined') {
            var order = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var rec = _a[_i];
                var o = {};
                o[this.codeKey] = rec[this.codeKey];
                o[this.dispKey] = rec[this.dispKey];
                order.push(o);
            }
            this.recs = order;
            this.setCompRec(order);
        }
    };
    SortComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    SortComponent.prototype.setCompRec = function (order) {
        this.action.setCompRec(this.componentName, { 'items': order });
    };
    SortComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        $(this.element).sortable('destroy');
    };
    SortComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'sort',
                    template: "<div id=\"{{ componentName }}\">\n  <p class=\"-mb-1\">{{ (msg | async)['SortComponent.label.note'] }}</p>\n  <div class=\"tableWrapper stageFlowPane_border -p-2\" style=\"max-height: 510px;\">\n    <table class=\"tableWrapper_table\" #sort>\n      <thead *ngIf=\"recs.length > 0\">\n      <tr data-href=\"#\">\n        <th></th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let rec of recs\" data-href=\"#\" id=\"{{ componentName + '_' + rec[codeKey] }}\" [attr.data-code]=\"rec[codeKey]\" [attr.data-display]=\"rec[dispKey]\">\n        <td style=\"white-space: normal;\">\n          <column-formlabel [col]=\"{key: dispKey}\" [val]=\"rec[dispKey]\" [msg]=\"(msg | async)\"></column-formlabel>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SortComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    SortComponent.propDecorators = {
        sortElement: [{ type: ViewChild, args: ['sort',] }]
    };
    return SortComponent;
}(ContentBaseComponent));
export { SortComponent };
//# sourceMappingURL=sort.component.js.map